<template>
  <div class="label">
    <div class="zy_constr">
      <div class="label-wrapper">
        <div class="label-info">
          <div class="label-title">精品厂牌</div>
          <div class="label-desc">
            面向多元圈层受众，掌阅推出多个短剧厂牌，率先围绕悬疑、女频甜宠、古装、玄幻等题材方向，推出镜渊剧场、告白剧场、千灯绘世、玄尊万象四大厂牌，在内容策划、视觉风格与叙事结构上实现系列化输出，夯实短剧精品化发展路径。
          </div>
        </div>
        <div class="label-list">
          <img v-for="(item, index) in labelList" :key="index" v-lazy="item" alt="" class="label-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LABEL } from '@/config';
import { isMobile } from '@/utils/utils';
export default {
  name: 'Label',
  data() {
    return {
      labelList: isMobile() ? LABEL.WAP : LABEL.PC
    };
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.label {
  padding-top: 48px;
}

.label-wrapper {
  border-radius: 16px;
  overflow: hidden;
  background-color: #f8f8fa;
}

.label-info {
  padding: 36px 48px;
}

.label-title {
  font-size: 24px;
  color: #000;
  line-height: 36px;
  font-weight: 500;
}

.label-desc {
  margin-top: 24px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
}

.label-list {
  display: flex;
}

.label-img {
  display: block;
  width: 25%;
  height: 590px;
}

.S {
  .label {
    margin-top: rem(72);
    margin-bottom: rem(36);
    padding: 0 rem(48);
  }
  .label-info {
    padding: rem(72) rem(36) rem(48);
  }
  .label-title {
    font-size: rem(48);
    line-height: rem(60);
    text-align: center;
  }
  .label-desc {
    font-size: rem(36);
    line-height: rem(54);
    margin-top: rem(48);
  }
  .label-list {
    border-radius: 0;
    flex-wrap: wrap;
    padding: 0 rem(36) rem(42);
  }
  .label-img {
    margin-bottom: rem(24);
    width: 100%;
    height: rem(240);
  }
}

/* Android 特定样式 */
@supports not (-webkit-touch-callout: none) {
  .S .label-title {
    font-weight: bold;
  }
}
</style>
